import { ComponentPropsWithoutRef, FC } from 'react';
import { Divider } from '@sravni/react-design-system';
import cn from 'classnames';
import styles from './styles.module.scss';
import { DesktopSubmitView } from '../desktop.submit';

type Props = ComponentPropsWithoutRef<'div'> & {
    nextBtnText?: string;
};

export const StickySubmit: FC<Props> = (props) => {
    const { className, nextBtnText } = props;

    return (
        <div className={cn(styles['sticky-submit'], className)}>
            <Divider />
            <div className={styles['sticky-submit__content-container']}>
                <DesktopSubmitView nextBtnText={nextBtnText} />
            </div>
        </div>
    );
};
